export default __webpack_public_path__ + "static/media/wwr-img.46811777.webp";